export default (function(window, document) {

  const hamButton = document.querySelector('.ham')
  const menu = document.querySelector('.menu')
  const header = document.querySelector('.header')
  const bodyScroll = document.body
  let hideHandler = null
  let showHandler = null

  function init() {
    hamButton.addEventListener('click', (e) => {
      e.preventDefault();

      if (menu.classList.contains('active')) {
        hide()
        return
      }

      show();
    })

    document.addEventListener('keyup', (e) => {
      // Not the escape key. Quit early
      if (e.keyCode !== 27) {
        return
      }

      menu.classList.remove('active')
      header.classList.remove('open')
    })
  }

  function bodyHandler(e) {
    if (menu.classList.contains('active')) {
      console.log('here 2')
      if (e.target.closest('.menu')) {
        return;
      }

      hide();
    }
  }

  function show() {
    return new Promise((resolve, reject) => {
      menu.classList.add('active')
      header.classList.add('open')
      bodyScroll.classList.add('u-overflow-hidden')

      showHandler = (e) => {
        if (e.target.classList.contains('menu')) {
          resolve()
        }

        menu.removeEventListener('transitionend', showHandler)
      }

      menu.addEventListener('transitionend', showHandler)

      setTimeout(() => {
        document.body.addEventListener('click', bodyHandler)
      })
    })
  }

  function hide() {
    return new Promise((resolve, reject) => {
      menu.classList.remove('active')
      header.classList.remove('open')
      bodyScroll.classList.remove('u-overflow-hidden')
      hideHandler = (e) => {
        if (e.target.classList.contains('menu')) {
          resolve()
        }

        menu.removeEventListener('transitionend', hideHandler)
      }

      menu.addEventListener('transitionend', hideHandler)

      document.body.removeEventListener('click', bodyHandler)
    })
  }

  function isActive() {
    return menu.classList.contains('active')
  }

  // u-display-none is added initially to prevent flickering.
  // This just removes it once the page is loaded.
  window.addEventListener('load', function() {
    menu.classList.remove('u-display-none');
  })

  return {
    init,
    show,
    hide,
    isActive,
  }

})(window, document);
